"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var vue_1 = __importDefault(require("vue"));
require("ngVue");
var CreateCourse_vue_1 = __importDefault(require("./CreateCourse.vue"));
var create_course_controller_1 = __importDefault(require("./create-course.controller"));
var admin_create_course_html_1 = __importDefault(require("./admin-create-course.html"));
function getCourseTypes(CourseTypesModel) {
    return CourseTypesModel.get({ status: "Active" }).then(function (response) {
        return response.courseTypes;
    });
}
getCourseTypes.$inject = ["CourseTypesModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.courses.create", {
        url: "/create",
        template: admin_create_course_html_1.default,
        controller: create_course_controller_1.default,
        controllerAs: "vm",
        resolve: {
            courseTypes: getCourseTypes,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.courses.create", [])
    .config(config)
    .controller("AdminCoursesCreateController", create_course_controller_1.default)
    .directive("dcCreateCourse", [
    "createVueComponent",
    function (createVueComponent) {
        return createVueComponent(vue_1.default.component("DcCreateCourse", CreateCourse_vue_1.default));
    },
]);
